export const BRIGHTCOVE_VIDEO_PLAYER_ID = 'Nr5YMm2WRW'
export const BRIGHTCOVE_VIDEO_BLOG_PLAYER_ID = 'qAEHsSC1j9'

export const getLocalPath = () => {
  return getPathAndEndpoint().path
}

export const getPathAndEndpoint = () => {
  if (window.location.pathname.startsWith('/cti-site')) {
    const pathSplit = window.location.pathname.split('/')
    if (pathSplit[2] === '_cmsinternal') {
      return {
        path: `/${pathSplit[1]}/${pathSplit[2]}/${pathSplit[3]}`,
        endpoint: `/${pathSplit[1]}/${pathSplit[3]}`,
      }
    } else if (pathSplit[3] === 'preview') {
      return {
        path: `/${pathSplit[1]}/${pathSplit[2]}/${pathSplit[3]}`,
        endpoint: `/${pathSplit[1]}/${pathSplit[2]}/${pathSplit[3]}`,
      }
    } else {
      return {
        path: `/${pathSplit[1]}/${pathSplit[2]}`,
        endpoint: `/${pathSplit[1]}/${pathSplit[2]}`,
      }
    }
  } else if (window.location.pathname.startsWith('/institutional/preview')) {
    return {
      path: `/institutional/preview`,
      endpoint: `/institutional/preview`,
    }
  } else if (window.location.pathname.startsWith('/institutional')) {
    return {
      path: `/institutional`,
      endpoint: `/institutional`,
    }
  } else if (window.location.pathname.startsWith('/insights/preview')) {
    return {
      path: `/insights/preview`,
      endpoint: `/insights/preview`,
    }
  } else if (
    ['/insights/latest-insights', '/insights/market-perspectives'].some((i) =>
      window.location.pathname.startsWith(i)
    )
  ) {
    return {
      path: `/insights`,
      endpoint: `/blogspa`,
    }
  } else if (
    ['/blogspa/preview'].some((i) => window.location.pathname.startsWith(i))
  ) {
    return {
      path: `/blogspa/preview`,
      endpoint: `/blogspa/preview`,
    }
  } else if (['/blogspa'].some((i) => window.location.pathname.startsWith(i))) {
    return {
      path: `/blogspa`,
      endpoint: `/blogspa`,
    }
  } else if (window.location.pathname.startsWith('/insights')) {
    return {
      path: `/insights`,
      endpoint: `/insights`,
    }
  } else if (window.location.pathname.startsWith('/advisor-insights/preview')) {
    return {
      path: `/advisor-insights/preview`,
      endpoint: `/advisor-insights/preview`,
    }
  } else if (window.location.pathname.startsWith('/advisor-insights')) {
    return {
      path: `/advisor-insights`,
      endpoint: `/advisor-insights`,
    }
  } else if (
    ['/advisor/preview'].some((i) => window.location.pathname.startsWith(i))
  ) {
    return {
      path: `/advisor/preview`,
      endpoint: `/advisor/preview`,
    }
  } else if (
    [
      '/advisor',
      '/about',
      '/resources',
      '/terms-of-use',
      '/privacy-security',
      '/corporate-entities',
      '/disclosures',
      '/privacy-statement',
      '/search',
      '/login',
      '/register',
      '/my-profile',
      '/investment-products',
      '/investment-capabilities',
      '/dare2tri',
      '/possefoundation',
      '/fixed-income',
      '/game-changer',
      '/social',
      '/user-agreement',
    ].some((i) => window.location.pathname.startsWith(i))
  ) {
    return {
      path: `/advisor`,
      endpoint: `/advisor`,
    }
  } else if (window.location.pathname.startsWith('/investorspa/preview')) {
    return {
      path: `/investorspa/preview`,
      endpoint: `/investorspa/preview`,
    }
  } else if (
    ['/investorspa', '/investor'].some((i) =>
      window.location.pathname.startsWith(i)
    )
  ) {
    return {
      path: `/investorspa`,
      endpoint: `/investorspa`,
    }
  } else if (
    ['/feature/preview'].some((i) => window.location.pathname.startsWith(i))
  ) {
    return {
      path: '/feature/preview',
      endpoint: '/feature/preview',
    }
  } else if (['/feature'].some((i) => window.location.pathname.startsWith(i))) {
    return {
      path: '/feature',
      endpoint: '/feature',
    }
  }

  return {
    path: '',
    endpoint: '',
  }
}

export const getSharedSiteName = (pathname = window.location.pathname) => {
  const siteName = getSiteName(pathname)

  if (siteName === 'cti-advisorspa') {
    return 'cti-advisor'
  } else if (siteName === 'cti-investorspa') {
    return 'cti-investor'
  } else if (siteName === 'cti-blogspa') {
    return 'blogspa'
  } else {
    return siteName
  }
}

export const getSiteName = (pathname = window.location.pathname) => {
  if (pathname.startsWith('/cti-site')) {
    return getLocalPath().replace('/cti-site/', '').replace('/preview', '')
  } else if (
    pathname.startsWith('/institutional') ||
    pathname.startsWith('/preview/institutional')
  ) {
    return `cti-institutional`
  } else if (
    [
      '/insights/latest-insights',
      '/insights/market-perspectives',
      '/blogspa',
    ].some((i) => pathname.startsWith(i))
  ) {
    return 'cti-blogspa'
  } else if (
    pathname.startsWith('/insights') ||
    pathname.startsWith('/preview/insights') ||
    pathname.startsWith('/advisor-insights') ||
    pathname.startsWith('/preview/advisor-insights')
  ) {
    return `cti-advisor-spa`
  } else if (
    [
      '/advisor',
      '/preview/advisor',
      '/about',
      '/preview/about',
      '/resources',
      '/preview/resources',
      '/investment-products',
      '/preview/investment-products',
      '/possefoundation',
      '/preview/possefoundation',
      '/dare2tri',
      '/preview/dare2tri',
      '/investment-capabilities',
      '/preview/investment-capabilities',
      '/fixed-income',
      '/game-changer',
      '/social',
      '/user-agreement',
    ].some((i) => pathname.startsWith(i))
  ) {
    return `cti-advisorspa`
  } else if (
    [
      '/investorspa',
      '/preview/investorspa',
      '/investor/resources',
      '/preview/investor/resources',
      '/investor/possefoundation',
      '/preview/investor/possefoundation',
      '/investor/dare2tri',
      '/preview/investor/dare2tri',
      '/investor/about',
      '/preview/investor/about',
      '/investor/investment-products',
      '/preview/investor/investment-products',
    ].some((i) => pathname.startsWith(i))
  ) {
    return `cti-investorspa`
  } else if (['/feature'].some((i) => pathname.startsWith(i))) {
    return `cti-featurepages`
  }
  return ''
}

export const isLocal = () => {
  return window.location.port
}

export const isCms = () => {
  return false
}

export const isDev = () => {
  return window.location.origin.indexOf('www.dev') > -1
}

export const isQa = () => {
  return window.location.origin.indexOf('www.qa') > -1
}

export const isQaWs3 = () => {
  return window.location.origin.indexOf('www-ws3.qa') > -1
}

export const isQaWs4 = () => {
  return window.location.origin.indexOf('www-ws4.qa') > -1
}

export const isQaWs5 = () => {
  return window.location.origin.indexOf('www-ws5.qa') > -1
}

export const isPreview = () => {
  return window.location.origin.indexOf('www-preview.') > -1
}

export const isPreprod = () => {
  return window.location.origin.indexOf('www-preprod.') > -1
}

export const isProduction = () => {
  return (
    window.location.origin.indexOf('www.columbia') > -1 ||
    window.location.origin.indexOf('www-preview.') > -1 ||
    window.location.origin.indexOf('www-preprod.') > -1
  )
}

export const isProduct = () => {
  return window.location.pathname.indexOf('/strategies-solutions') > -1
}

export const isIntegratedProduct = () => {
  return window.location.pathname.indexOf('/integrated-equity') > -1
}

const getInvestorPathname = (pathname) => {
  return pathname
    .split('/')
    .filter((item) => item !== 'investor')
    .join('/')
}

export const getDebugConfig = () => {
  let endpoint

  if (isLocal()) {
    endpoint =
      'http://localhost:8081' + getPathAndEndpoint().endpoint + '/resourceapi'
  } else if (isDev()) {
    endpoint =
      'https://www.dev.columbiathreadneedleus.com' +
      getPathAndEndpoint().endpoint +
      '/resourceapi'
  } else if (isQaWs3()) {
    endpoint =
      'https://www-ws3.qa.columbiathreadneedleus.com' +
      getPathAndEndpoint().endpoint +
      '/resourceapi'
  } else if (isQaWs4()) {
    endpoint =
      'https://www-ws4.qa.columbiathreadneedleus.com' +
      getPathAndEndpoint().endpoint +
      '/resourceapi'
  } else if (isQaWs5()) {
    endpoint =
      'https://www-ws5.qa.columbiathreadneedleus.com' +
      getPathAndEndpoint().endpoint +
      '/resourceapi'
  } else if (isQa()) {
    endpoint =
      'https://www.qa.columbiathreadneedleus.com' +
      getPathAndEndpoint().endpoint +
      '/resourceapi'
  } else if (isPreview()) {
    endpoint =
      'https://www-preview.columbiathreadneedleus.com' +
      getPathAndEndpoint().endpoint +
      '/resourceapi'
  } else if (isPreprod()) {
    endpoint =
      'https://www-preprod.columbiathreadneedleus.com' +
      getPathAndEndpoint().endpoint +
      '/resourceapi'
  } else if (isProduction()) {
    endpoint =
      'https://www.columbiathreadneedleus.com' +
      getPathAndEndpoint().endpoint +
      '/resourceapi'
  }

  let origin

  if (isLocal()) {
    origin = undefined
  } else if (isDev()) {
    origin = 'https://cms.dev.ameriprise.com'
  } else if (isQaWs3()) {
    origin = 'https://cms-ws3.qa.ameriprise.com'
  } else if (isQaWs4()) {
    origin = 'https://cms-ws4.qa.ameriprise.com'
  } else if (isQaWs5()) {
    origin = 'https://cms-ws5.qa.ameriprise.com'
  } else if (isQa()) {
    origin = 'https://cms.qa.ameriprise.com'
  } else if (isPreview() || isPreprod() || isProduction()) {
    origin = 'https://cms.ameriprise.com'
  }

  const path = `${
    window.location.pathname.startsWith('/investor/')
      ? getInvestorPathname(window.location.pathname)
      : window.location.pathname.replace(getLocalPath(), '')
  }${window.location.search}`

  return {
    PATH: path,
    ENDPOINT: endpoint,
    DEBUG: false,
    ORIGIN: origin,
  }
}
